import axios from 'config/axios'
import { ApiKey } from 'config/enums'
import { useQuery } from '@tanstack/react-query'
import { ApiEndpoints } from 'config/endpoints'
import { store } from 'config/user/store'

const getMe = async () => {
  return axios.get(ApiEndpoints.AuthMe)
}

export const useGetMe = (auth: boolean) => {
  const lang = store.getState().locale.lang

  return useQuery([ApiKey.Me, lang], () => getMe(), {
    keepPreviousData: true,
    enabled: auth,
  })
}
